/**
 * Default values for image generation
 */

import type { ImageGenerationSettings, ImageGenerationState } from '../types'

// Default settings
export const DEFAULT_SETTINGS: ImageGenerationSettings = {
  selectedModel: 'NANO_BANANA',
  selectedStyle: 'none',
  selectedImageSize: 'square',
  aspectRatioIndex: 0,
  numberOfImages: 1,
  showExamplePrompts: true,
  keepPrompt: false,
  backgroundImage: 'auto',
  negativePrompt: '',
  ns11Style: 'none',
  ns11Pages: 1,
  nanoBananaImageSize: '1k',
  system_instruction: '',
}

// Default state
export const DEFAULT_STATE: ImageGenerationState = {
  prompt: '',
  isGenerating: false,
  showHistory: false,
  conversationId: null,
  generationHistory: [],
  examplePrompts: [],
  currentExamples: [],
  showImageModal: false,
  selectedImageData: null,
  uploadedFiles: [],
  isUploading: false,
  showFileUpload: false,
}

// Create fresh settings (for resetting)
export function createDefaultSettings(): ImageGenerationSettings {
  return { ...DEFAULT_SETTINGS }
}

// Create fresh state (for resetting)
export function createDefaultState(): ImageGenerationState {
  return {
    ...DEFAULT_STATE,
    generationHistory: [],
    examplePrompts: [],
    currentExamples: [],
    uploadedFiles: [],
  }
}
